import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/auth';
import 'firebase/storage';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { User } from '../_models/user';
import { AntEnvService } from './ant.env.svc';

@Injectable()
export abstract class AbsAuthService{
    user:any;

    abstract login(email: string, password: string);
    abstract getCurrentUser();
    abstract setCurrentUser(argUser: any);
}

@Injectable({ providedIn: 'root' })
export class AuthService implements AbsAuthService {
    
    user: any;
    fullScreen: boolean = false;

    constructor(
        //private http: HttpClient,
        private fireAuth: AngularFireAuth
    ) {
        this.user = fireAuth.authState;
    }
    public getData(): any[] {
        return [ 'Game of Thrones', 'Breaking Bad', 'The Walking Dead' ];
    }
    login(email: string, password: string): Promise<firebase.default.auth.UserCredential> {
        return this.fireAuth.signInWithEmailAndPassword(email, password);
        // .then(res=>{
        // }).catch(err => {
        // });
    }
    // login(email: string, password: string): Promise<firebase.auth.UserCredential> {
    //     return this.firebaseAuth.auth.signInWithEmailAndPassword(email, password);
    //     // .then(res=>{
    //     //     console.log('Success');
    //     // }).catch(err => {
    //     //     console.log('Something went wrong: ' + err.message);
    //     // });
    // }
    // resetPassword(email: string) {
    //     return this.firebaseAuth.auth.sendPasswordResetEmail(email);
    // }
    // logout() {
    //     this.firebaseAuth.auth.signOut();
    // }
    // signUp(email: string, password: string): Promise<firebase.auth.UserCredential> {
    //     return this.firebaseAuth.auth.createUserAndRetrieveDataWithEmailAndPassword(email, password);
    // }
    getCurrentUser(){
        // let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        // if (currentUser && currentUser.Token) {
        //     return currentUser;
        // }
        return null;
    }
    setCurrentUser(argUser){
        this.user = of(argUser);
        localStorage.setItem('currentUser', JSON.stringify(argUser));  // store user details and jwt token in local storage to keep user logged in between page refreshes
        //this.isAuthOk= true;
    }
    // deleteAccount(uid): Observable<any> {
    //     var url = 'https://us-central1-.cloudfunctions.net/deleteUser';
    //     return this.http.post(url, { uid: uid });
    // }
    // userGetAll(): Observable<any> {
    //     var url = 'https://us-central1-.cloudfunctions.net/userAll';
    //     return this.http.post(url, {});
    // }
    // userCreate(user): Observable<any> {
    //     var url = 'https://us-central1-.cloudfunctions.net/userCreate';
    //     return this.http.post(url, user);
    // }
    // userCreateList(userList): Observable<any> {
    //     var url = 'https://us-central1-.cloudfunctions.net/userCreateList';
    //     return this.http.post(url, { userList: userList });
    // }
    // userReset(): Observable<any> {
    //     var url = 'https://us-central1-.cloudfunctions.net/userReset';
    //     return this.http.post(url, {});
    // }
}

@Injectable({providedIn: 'root'})
export class AuthApiService implements AbsAuthService{

    private headers4Cors = { headers: {'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' } };
    apiUrl: string = environment.apiUrl;

    isAuthOk: boolean = false;
    user: Observable<User>;

    constructor(
        private http: HttpClient,
        private svcAntEnv: AntEnvService
    ){
        this.svcAntEnv.load().subscribe(res=>{
            if(res.apiUrl != null){
                this.apiUrl = res.apiUrl;
            }
        });
    }

    login(username:string, password:string): Observable<any>{
        var url = `${this.apiUrl}/api/user/login`;
        //console.log('login>>', url, username, password);
        return this.http.post(url, { email: username, password: password }, this.headers4Cors);
    }
    loginV01(username: string, password: string) {
        return this.http.post<any>(`${environment.apiUrl}/account/portal/class/authenticate/login`, {LoginName: username, Password: password })
            .pipe(map(resUser => {
                this.isAuthOk= false;
                if (resUser && resUser.Token) {   // login successful if there's a jwt token in the response
                    //console.log('success');
                    //console.log(resUser);
                    localStorage.setItem('currentUser', JSON.stringify(resUser));  // store user details and jwt token in local storage to keep user logged in between page refreshes
                    this.isAuthOk= true;
                }
                this.user = of(resUser);
                return resUser;
            }));
    }
    getCurrentUser(){
        var res = localStorage.getItem('currentUser');
        if(!res){
            return null;
        }
        let currentUser = JSON.parse(res);
        if (currentUser && currentUser.token) {
            return currentUser;
        }
        return null;
    }
    setCurrentUser(argUser){
        this.user = of(argUser);
        localStorage.setItem('currentUser', JSON.stringify(argUser));  // store user details and jwt token in local storage to keep user logged in between page refreshes
        this.isAuthOk= true;
    }
    logout() {
        localStorage.removeItem('currentUser'); // remove user from local storage to log user out
        
        localStorage.removeItem('fcmToken');
    }
}
